import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

function mountApp(container) {
  createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Case 1: #ft-root is directly on the page (not inside a popup)
const el = document.getElementById('ft-root');
if (el && el.offsetParent !== null) {
  mountApp(el);
} else {
  // Case 2: #ft-root is inside an Elementor popup.
  // Elementor destroys popup content on close and recreates on open,
  // so we must re-mount React each time the popup opens.
  let currentRoot = null;

  new MutationObserver(() => {
    const popup = document.querySelector('.elementor-popup-modal[style=""]');
    const target = popup?.querySelector('#ft-root');

    if (target && target !== currentRoot) {
      currentRoot = target;
      mountApp(target);
    }

    if (!popup) {
      currentRoot = null;
    }
  }).observe(document.body, { childList: true, subtree: true, attributes: true });
}
